import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useMember } from "../../context/memberContext";
import { useTranslations } from "../../hooks/useTranslations";
import { Permission } from "../../types";
import SVGAdd from "../../icons/Add.svg?react";
import Button from "../ui/Button";
import NavTabs from "../ui/NavTabs";
import Page from "../ui/Page";
import MemberInvites from "./MemberInvites";
import MemberUsers from "./MemberUsers";

const MemberSettings = () => {
  const { i18n } = useTranslations();
  const navigate = useNavigate();
  const { member } = useMember();
  const canWrite = member?.permissions?.includes(Permission.MemberUsersWrite);

  return (
    <Page
      title={i18n.memberSettings.title}
      description={i18n.memberSettings.description}
      actions={
        canWrite ? (
          <Button
            glyph={SVGAdd}
            buttonProps={{ onClick: () => navigate("benutzer/neu") }}
          >
            {i18n.memberSettings.inviteUser}
          </Button>
        ) : undefined
      }
    >
      <NavTabs
        tabs={[
          { to: "benutzer", text: i18n.memberSettings.tabs.users },
          { to: "einladungen", text: i18n.memberSettings.tabs.invites },
        ]}
      />
      <Routes>
        <Route path="benutzer" element={<MemberUsers />} />
        <Route path="einladungen" element={<MemberInvites />} />
        <Route path="*" element={<Navigate to="benutzer" replace />} />
      </Routes>
    </Page>
  );
};

export default MemberSettings;
